import { render } from "./PpcBidSettingsHistoryPopover.vue?vue&type=template&id=01639e84&scoped=true"
import script from "./PpcBidSettingsHistoryPopover.vue?vue&type=script&lang=js"
export * from "./PpcBidSettingsHistoryPopover.vue?vue&type=script&lang=js"

import "./PpcBidSettingsHistoryPopover.vue?vue&type=style&index=0&id=01639e84&lang=css"
import "./PpcBidSettingsHistoryPopover.vue?vue&type=style&index=1&id=01639e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01639e84"]])

export default __exports__